import React from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends HTMLMotionProps<'button'> {
  variant?: 'primary' | 'secondary' | 'outline';
  isLoading?: boolean;
  children: React.ReactNode;
}
export function Button({
  variant = 'primary',
  isLoading,
  children,
  className = '',
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-6 py-3 rounded-lg font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-[#0a0a0a] disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-[#0ea5e9] text-white hover:bg-[#0284c7] focus:ring-[#0ea5e9]',
    secondary: 'bg-[#10b981] text-white hover:bg-[#059669] focus:ring-[#10b981]',
    outline: 'border-2 border-[#333] text-gray-300 hover:border-[#0ea5e9] hover:text-[#0ea5e9] focus:ring-[#0ea5e9] bg-transparent'
  };
  return <motion.button whileHover={{
    scale: disabled || isLoading ? 1 : 1.02
  }} whileTap={{
    scale: disabled || isLoading ? 1 : 0.98
  }} className={`${baseStyles} ${variants[variant]} ${className}`} disabled={disabled || isLoading} {...props} data-id="element-157">
      {isLoading && <Loader2 className="w-4 h-4 mr-2 animate-spin" data-id="element-158" />}
      {children}
    </motion.button>;
}